<!--
    @name: widget-date-range
    @description：widget-date-range
    @author: ZengWei
    @date: 2022-03-25 09:37
-->
<template>
  <div>
    <div v-if="disabled || element.config.disabled" class="input-show">
      {{ getDateRange }}
    </div>
    <el-date-picker
      v-else
      v-model="element.value"
      :disabled="disabled || element.config.disabled"
      :type="element.config.type"
      :range-separator="element.config['range-separator']"
      :format="element.config.format"
      :placeholder="element.config.placeholder"
      :value-format="element.config['value-format']"
      :default-time="element.config.__config__.defaultTime?.split(',')"
      :picker-options="pickerOptions"
      @change="onChange"
      style="width: 100%"
    >
    </el-date-picker>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui';
import formItemMinix from '@/custom-component/form/newParser/scripts/formItemMinix';
import { dateFormat } from '@/custom-component/form/newParser/scripts/tools';

export default {
  name: 'WidgetDateRange',
  components: {
    'el-date-picker': DatePicker,
  },
  mixins: [formItemMinix],
  props: ['element', 'disabled', 'displayData'],
  data() {
    return {
      maxEndDate: '',
      pickerOptions: {
        disabledDate: (time) => {
          const pre = 1 * 24 * 3600 * 1000;
          const minTime = Date.now() - pre;
          const preDate = this.element.config.__config__.preDate || false;
          const afterDate = this.element.config.__config__.afterDate || false;
          const days = this.element.config.__config__.days || 0;
          const includesToday = this.element.config.__config__.includesToday || false;
          if (preDate) {
            if(includesToday) return time.getTime() < Date.now();
            return time.getTime() < minTime;
          }
          if (afterDate) {
            if(includesToday) return time.getTime() > minTime;
            return time.getTime() > Date.now();
          }
          if (days) {
            const one = days * 24 * 3600 * 1000;
            const maxTime = Date.now() + one;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        },
        onPick: ({ minDate, maxDate }) => {
          const preDate = this.element.config.__config__.preDate || false;
          const afterDate = this.element.config.__config__.afterDate || false;
          const days = this.element.config.__config__.days || 0;
          const fmt = this.element.config['value-format'];
          if ((preDate || afterDate) && days && maxDate) {
            const one = days * 24 * 3600 * 1000;
            const maxTime = minDate.getTime() + one;
            if (maxDate.getTime() > maxTime) {
              this.$message.error(
                `日期范围最多只能选【${days}】天，已自动更改截止时间`
              );
              const maxDatetime = new Date(maxTime);
              this.maxEndDate = dateFormat(fmt, maxDatetime);
            }
          }
        },
      },
    };
  },
  computed: {
    getDateRange() {
      const dataRange = this.element.value;
      let result = dataRange.map((el) => {
        return el.split('-').join('/');
      });
      if (Array.isArray(result) && result.length) {
        return result.join(' - ');
      } else {
        return '-';
      }
    },
  },
	methods: {
		onChange() {
			if (this.maxEndDate) {
				this.element.value[1] = this.maxEndDate;
			}
			this.triggerInteractive(this.element.value);
		},
		formatDate(date, format = "yyyy-MM-dd") {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			const hour = String(date.getHours()).padStart(2, "0");
			const minute = String(date.getMinutes()).padStart(2, "0");
			const second = String(date.getSeconds()).padStart(2, "0");

			return format
				.replace("yyyy", year)
				.replace("MM", month)
				.replace("dd", day)
				.replace("HH", hour)
				.replace("mm", minute)
				.replace("ss", second);
		},
		getCurrentDate(format = "yyyy-MM-dd",fixedTime = null) {
			const now = new Date();
			if (fixedTime && format.includes("HH")) {
					const [fixedHour, fixedMinute, fixedSecond] = fixedTime.split(":").map(Number);
					const currentHour = now.getHours();
					const currentMinute = now.getMinutes();
					const currentSecond = now.getSeconds();

					// 如果当前时间超过固定时间，则使用固定时间
					if (
							currentHour < fixedHour ||
							(currentHour === fixedHour && currentMinute < fixedMinute) ||
							(currentHour === fixedHour && currentMinute === fixedMinute && currentSecond < fixedSecond)
					) {
							now.setHours(fixedHour, fixedMinute, fixedSecond);
					}
			}
			return this.formatDate(now, format);
		},
		getFutureDates(days,format = "yyyy-MM-dd", fixedTime = null) {
			const date = new Date();
			date.setDate(date.getDate() + days); // 增加天数

			if (fixedTime && format.includes("HH")) {
				const [fixedHour, fixedMinute, fixedSecond] = fixedTime.split(":").map(Number);
				// const currentHour = date.getHours();
				// const currentMinute = date.getMinutes();
				// const currentSecond = date.getSeconds();

				// 如果当前时间超过固定时间，则使用固定时间
				if (
					fixedTime
				) {
						date.setHours(fixedHour, fixedMinute, fixedSecond);
				}
			}

			return this.formatDate(date, format);
		}
	},  
	mounted() {
		if(this.element.config?.__config__?.innerDay){
			const defaultTime =  this.element.config.__config__.defaultTime?.split(',')
			this.element.value = [this.getCurrentDate(this.element.config.format,defaultTime[0]),this.getFutureDates(this.element.config?.__config__?.innerDay,this.element.config.format,defaultTime[1])]
		}
	},
};
</script>

<style scoped></style>
